export { LanguageProvider, useTranslation } from './context';
export type { Locale } from './locale';
export { plural } from './plural';

export { interpolate } from './interpolate';
